import * as http from './http';
import * as client from './client';
import * as resource from './resource';

export default { ...http, ...client, ...resource };
